import { render, staticRenderFns } from "./ImageAndText.vue?vue&type=template&id=dfdff4de&scoped=true&"
import script from "./ImageAndText.vue?vue&type=script&lang=js&"
export * from "./ImageAndText.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndText.vue?vue&type=style&index=0&id=dfdff4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdff4de",
  null
  
)

export default component.exports